import { z } from "zod";

export const triggerGenerateBriefingResponseSchema = z.object({
  id: z.string(),
  status: z.string(),
  progress: z.number(),
});

export const briefingGenerationStatusSchema = z.union([z.literal("Processing"), z.literal("Error"), z.literal("Done")]);

export const monitorProgressGenerateBriefingResponseSchema = z.object({
  id: z.string(),
  status: briefingGenerationStatusSchema,
  progress: z.number(),
});

export const fetchBriefingResponseSchema = z.object({
  live_briefing_url: z.string(),
});
